import BraintreeHostedFieldRegistry from '@root/payments/src/services/braintree/braintree-hosted-field-registry';
import BraintreeResult from '@root/payments/src/services/braintree/braintree-result';
import BraintreeService from '@root/payments/src/services/braintree/braintree-service';

export default BraintreeService;
export { BraintreeHostedFieldRegistry, BraintreeResult };
